import { useEffect } from 'react';
import { loadFileData } from '../../../../utils/fileUtils';

export const useRepeatProcessingLoader = ({
    locationState,
    setFiles,
    setIsLoading,
    setIsInitializing,
    showError,
    isMounted,
    onLoaded,
}) => {
    useEffect(() => {
        if (
            locationState?.isRepeatProcessing &&
            locationState?.originalFileNames &&
            locationState?.oldInputIdentifier
        ) {
            loadFilesFromHistory(
                locationState.oldInputIdentifier,
                locationState.originalFileNames,
                locationState.extensionMap
            );
        }
    }, [locationState]);

    const loadFilesFromHistory = async (
        oldInputIdentifier,
        originalFileNames,
        extensionMap = {}
    ) => {
        setIsInitializing(true);
        setIsLoading(true);

        try {
            const filesData = await loadFileData(
                oldInputIdentifier,
                originalFileNames,
                extensionMap
            );

            if (isMounted.current) {
                setFiles(filesData);
                onLoaded?.(locationState);
            }
        } catch (error) {
            if (isMounted.current) {
                showError(`Ошибка загрузки файлов: ${error.message}`);
            }
        } finally {
            if (isMounted.current) {
                setIsInitializing(false);
                setIsLoading(false);
            }
        }
    };
};